import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import ClientCommandDialog from "./ClientCommandDialog";

import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialDialog from "../../../styles/materialDialog";
import { StyledAbstractCommandWrapper } from "../styledSystemCommand";

const AbstractClientCommand = ({ t, notification, setNotification, commandUrl, description }) => {

  const [data, setData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const runCommand = () => {
    setLoading(true);

    axios.post("/api/system-command/" + commandUrl, data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setNotification({ ...notification, visible: true, type: "success", message: "Command successfully executed" });
        setOpenModal(false);
        setData({});
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <StyledAbstractCommandWrapper>
      <div className="command__description">
        {description}
      </div>
      <div className="command__actions">
        <DefaultButton
          onClick={() => setOpenModal(true)}
          color="success"
        >
          Run
        </DefaultButton>
        <MaterialDialog
          open={openModal}
        >
          <ClientCommandDialog
            t={t}
            setOpen={setOpenModal}
            data={data}
            setData={setData}
            handleSubmit={runCommand}
            loading={loading}
          />
        </MaterialDialog>
      </div>
    </StyledAbstractCommandWrapper>
  );
};

export default AbstractClientCommand;